"use client";
import * as React from "react";
const SvgExternalSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.222 8.889v5.333H1.778V1.778H7.11V0H0v16h16V8.889h-1.778ZM12.96 1.778H9.707V0h6.284v6.284h-1.769V3.04l-6.08 6.08L6.89 7.867l6.071-6.09Z" }));
export {
  SvgExternalSharp as default
};
